import React, { useEffect, useState } from "react";

const QuestionMultiChoice = ({
	question,
	defaultValue,
	onAnswer,
	handleNext,
}) => {
	const [selectedOptions, setSelectedOptions] = useState(null);
	const [showResult, setShowResult] = useState(false);
	const [showOptions, setShowOptions] = useState(true);
	const [buttonWidth, setButtonWidth] = useState("w-full"); // Default to full width

	useEffect(() => {
		setShowResult(false);
		setSelectedOptions(defaultValue);
		setShowOptions(true);

		// Determine max button width based on longest label
		if (question.options.length > 0) {
			const longestLabel = Math.max(
				...question.options.map((opt) => opt.label.length)
			);
			if (longestLabel > 15) setButtonWidth("w-48"); // Large labels
			else if (longestLabel > 10) setButtonWidth("w-36"); // Medium labels
			else setButtonWidth("w-28"); // Small labels
		}
	}, [question]);

	const submitAnswer = () => {
		if (selectedOptions !== null) {
			onAnswer(selectedOptions);
			setShowResult(true);
		}
	};

	return (
		<div>
			<div className="relative flex flex-col items-center bg-white p-6 px-6 rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)]">
				{question.category && (
					<div className="text-sm text-gray-800 font-bold mb-2">
						{question.category}:
					</div>
				)}
				<h3 className="text-sm mb-4">{question.text}</h3>
				{question.options.map((option, index) => (
					<div key={index} className="flex items-center mb-2">
						<input
							type="checkbox"
							id={`option-${index}`}
							checked={defaultValue?.includes(option.value)}
							onChange={() => onAnswer(option.value)}
							className="mr-2"
						/>
						<label htmlFor={`option-${index}`} className="text-left">
							{option.label}
						</label>
					</div>
				))}
			</div>
			<div className="mt-4 h-24 px-4 flex w-full justify-end items-center gap-0">
				{showResult ? (
					<button
						onClick={handleNext}
						className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
					>
						Continuer
					</button>
				) : (
					<button
						onClick={submitAnswer}
						className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
					>
						Continuer
					</button>
				)}
			</div>
		</div>
	);
};

export default QuestionMultiChoice;
